import { graphql, useStaticQuery } from 'gatsby'
import storeConfig from '../../../../../store.config'

type PrivateAreaLinksProps = {
  givenName: string | null
  email: string | null
}

type LoggedItem = {
  label: string
  url: string
}

export const PrivateAreaLinks = ({
  givenName,
  email,
}: PrivateAreaLinksProps) => {
  const loggedItems = useStaticQuery(graphql`
    query MyAccountLoggedQuery {
      cmsMyAccount {
        areaPrivata {
          myAccountData {
            loggedItems {
              label
              url
            }
          }
        }
      }
    }
  `)

  const returnUrl = `${storeConfig.storeUrl}/logout`

  return (
    <div className="absolute right-0 top-10 md:top-[65px] 3xl:top-[72px] max-w-[calc(100vw-80px)] md:max-w-[calc(100vw-160px)] opacity-0 -z-1 flex flex-row bg-white rounded-lg shadow-[0px_-1px_5px_0px_rgba(0,0,0,0.16),0px_2px_16px_0px_rgba(0,0,0,0.08)] overflow-hidden dropdown-subheader-body">
      <div className="py-6 px-6 min-w-[240px] space-y-3">
        <div className="pb-2">
          <p className="text-base !leading-[130%] tracking-[-0.48px] font-semibold">
            Ciao {givenName}
          </p>
          <p className="text-[10px] !leading-[130%] tracking-[0.025px] font-normal h-[18px]">
            {email}
          </p>
        </div>
        <div className="border-t border-solid border-[#E2E2E2] pt-3 flex flex-col gap-2 [&amp;>*:first-child]:mt-1">
          {loggedItems.cmsMyAccount.areaPrivata.myAccountData.loggedItems.map(
            (item: LoggedItem, index: number) => (
              <a
                key={`private-area-item-${index}`}
                href={`${item.url}`}
                className="py-1 block text-base font-normal !leading-[130%] tracking-[0.08px] text-black no-underline hover:underline"
              >
                {item.label}
              </a>
            )
          )}
          <a
            href={`${storeConfig.secureSubdomain}/api/vtexid/pub/logout?scope=${storeConfig.account}&returnUrl=${returnUrl}`}
            className="py-1 block text-base font-normal !leading-[130%] tracking-[0.08px] account-button text-black no-underline hover:underline"
          >
            Non sei tu? <span className="underline text-red-600">Esci</span>
          </a>
        </div>
      </div>
    </div>
  )
}
